import { render, staticRenderFns } from "./PromotionMaintain.vue?vue&type=template&id=4bffe802&"
import script from "./PromotionMaintain.vue?vue&type=script&lang=js&"
export * from "./PromotionMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bffe802')) {
      api.createRecord('4bffe802', component.options)
    } else {
      api.reload('4bffe802', component.options)
    }
    module.hot.accept("./PromotionMaintain.vue?vue&type=template&id=4bffe802&", function () {
      api.rerender('4bffe802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/promotion/PromotionMaintain.vue"
export default component.exports